<template>
    <div class="main">
        <header-component :prevRoute="previousRoute"/>
        <navigation-component />
        <keep-alive include="Home">
            <router-view />
        </keep-alive>
        <root-modal v-model="modal"></root-modal>
    </div>
</template>

<script>
import HeaderComponent from '@/views/Private/Components/Header/HeaderRoot'
import NavigationComponent from '@/views/Private/Components/Navigation'
import RootModal from '@/views/Private/Components/Modal/RootModal'
import { EventBus } from '@/services/eventbus'

export default {
  name: 'PrivateLayout',
  components: {
    HeaderComponent,
    NavigationComponent,
    RootModal
  },
  data () {
    return {
      modal: {
        type: '',
        data: {},
        header: false
      },
      previousRoute: null
    }
  },
  watch: {
    '$route': function (newVal, oldVal) {
      if (oldVal) {
        this.previousRoute = oldVal.name
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousRoute = from.name
    })
  },
  created () {
    EventBus.$on('open-modal', (payload) => {
      this.modal.type = payload.type
      this.modal.data = payload.data
      this.modal.header = payload.header
    })
  },
  beforeDestroy () {
    EventBus.$off('open-modal', true)
  }
}
</script>
